import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class UIService {

	onVideoCreated: EventEmitter<any> = new EventEmitter();

	constructor() { }

}
